module.exports = "<app-navbar></app-navbar>\n\n<div class=\"container p-4\">\n    <router-outlet></router-outlet>\n</div>"